import React from 'react';
import { Svg } from 'day8-react/build/new-components';
import { FaCircleInfo } from "@react-icons/all-files/fa6/FaCircleInfo";
var HeaderItem = function (_a) {
    var icon = _a.icon, title = _a.title, subTitle = _a.subTitle, _b = _a.hasTooltip, hasTooltip = _b === void 0 ? false : _b;
    return (React.createElement("div", null,
        React.createElement("div", { className: "dui-text-center" },
            React.createElement(Svg, { className: "icon--md", name: icon, fill: "var(--color-contrast-medium)" })),
        React.createElement("p", { className: "dui-font-bold dui-text-center dui-text-sm" },
            title,
            hasTooltip && React.createElement(FaCircleInfo, { className: "dui-inline-flex dui-ml-2 dui-text-gray-400" })),
        React.createElement("p", { className: "dui-font-semibold dui-text-center dui-text-gray-400 dui-text-sm" }, subTitle)));
};
export default HeaderItem;
